import { useEffect, useState } from 'react';
import Image from 'next/image';
import { useArticles } from './hooks/useArticles';
import timeIcon from '../../../public/time_Icon.svg';
import { ArticlePost } from './ArticlePost';
import { ArticleCategory } from './ArticleCategory';

export const Article = () => {
  const [categoryId, setCategoryId] = useState<number>();
  const { articles: allArticles } = useArticles();
  const articles = allArticles?.find(({ category }) => category.id === categoryId)?.articles || [];

  useEffect(() => {
    if (allArticles && allArticles.length > 0) {
      setCategoryId(allArticles[0].category.id);
    }
  }, [allArticles]);

  return (
    <div>
      <div className="flex overflow-x-scroll whitespace-nowrap">
        <ul className="flex list-none overflow-x-scroll ml-3 mb-[10px] mr-4">
          {allArticles && allArticles.length > 0 ? (
            allArticles.map(({ category }) => 
                <ArticleCategory
                  key={category.id}
                  category={category}
                  selected={category.id === categoryId}
                  onClick={() => setCategoryId(category.id)}
                /> 
            )
          ) : (
            <div>現在記事はありません</div>
          )}
        </ul>
      </div>
      {articles && (
        <ul className="flex overflow-x-scroll whitespace-nowrap items-stretch h-auto ml-3 mr-4">
          {articles.map((item) => (
            <ArticlePost articles={item} key={item.id} />
          ))}
          <div className="table-cell w-52 object-cover relative h-[205px] ml-4">
            <a href="https://raysee.jp/column/" target="_blank">
              <div className="absolute inset-0 bg-black bg-opacity-80  rounded-lg"></div>
              <Image
                width={200}
                height={100}
                src="https://i0.wp.com/fukudake3ea3cd852.wpcomstaging.com/wp-content/uploads/2023/10/27627498_s.jpg?fit=640%2C394&amp;ssl=1"
                className="object-cover rounded-t-lg"
                alt={'記事のサムネイル画像'}
              />
              <div className="absolute inset-0 flex items-center justify-center text-white text-lg font-semibold">
                もっと見る
              </div>
              <div className=" w-52 text-sm whitespace-normal pt-[10px] pb-[15px] pl-[15px] pr-[15px]">
                <div className="flex mb-1">
                  <Image src={timeIcon} width={12} height={12} alt={''} />
                  <p className="pl-1 text-xs">2023年10月18日</p>
                </div>
                <p className="text-xs font-bold text-ellipsis line-clamp-2">
                  10歳以上年下男性の恋愛心理とは？年の差恋愛を成就させる方法！
                </p>
              </div>
            </a>
          </div>
        </ul>
      )}
    </div>
  );
};
